import script from "./dealsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./dealsInfo.vue?vue&type=script&setup=true&lang=js"

import "./dealsInfo.vue?vue&type=style&index=0&id=1e08d3de&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e08d3de"]])

export default __exports__